// spot
//------------------------------------------------------------
$(function(){

    // SPOT Index
    if( $("body").is("#course") ){

        var parent = $(".map-link");
        let cid;

        //いずれかをホバー時
        $("[data-cid], [data-mapid]", parent).hover(
            function(){
                if( $(this).data("mapid") ){ cid = $(this).data("mapid"); }
                if( $(this).data("cid") ){ cid = $(this).data("cid"); }
                $("[data-cid="+ cid +"], [data-mapid="+ cid +"]", parent).addClass("hover");
                parent.attr("data-current", cid);
            },
            function(){
                if( $(this).data("mapid") ){ cid = $(this).data("mapid"); }
                if( $(this).data("cid") ){ cid = $(this).data("cid"); }
                $("[data-cid="+ cid +"], [data-mapid="+ cid +"]", parent).removeClass("hover");
                parent.attr("data-current", "");
            }
        );

    }
});



// WEBPACK FOOTER //
// ./_src/js/cont/course.js